"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiveTaskViewModel = void 0;
const ActivityViewModel_1 = require("./ActivityViewModel");
class ReceiveTaskViewModel extends ActivityViewModel_1.ActivityViewModel {
    constructor(receiveTask, processModel) {
        var _a, _b;
        super(receiveTask, processModel);
        this.messageName = (_a = receiveTask.messageEventDefinition) === null || _a === void 0 ? void 0 : _a.name;
        this.messageId = (_b = receiveTask.messageEventDefinition) === null || _b === void 0 ? void 0 : _b.id;
    }
}
exports.ReceiveTaskViewModel = ReceiveTaskViewModel;
//# sourceMappingURL=ReceiveTaskViewModel.js.map